module.exports = __webpack_public_path__ + "img/promocodes_promo.cc04f3a2.png";